module.exports = __webpack_public_path__ + "img/d2.fee70cef.png";